import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Footer } from 'client/components/UI/Footer';
import { Header } from 'client/components/UI/Header';
import { ProcessingOverlay } from 'common/components/UI/ProcessingOverlay';
import background from 'img/background.png';
import { Outlet } from 'react-router-dom';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        backgroundAttachment: 'fixed',
        backgroundImage: `url(${background})`,
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    content: {
        flex: '1 0 auto',
        zIndex: 1,
    },
});

export function UserClient({ children }: { children?: JSX.Element }) {
    const classes = useStyles();

    return (
        <main className={classes.container}>
            <Header />
            <div className={classes.content}>
                <React.Suspense fallback={<ProcessingOverlay enabled />}>{children ? children : <Outlet />}</React.Suspense>
            </div>
            <Footer />
        </main>
    );
}
